<template>
  <VueDatetime
    class="_InputDateTime_datetime_1OczR"
    :class="color"
    :type="type"
    :value="value"
    :inputId="id"
    :inputClass="inputClasses"
    :minDatetime="minDatetime"
    :maxDatetime="maxDatetime"
    :valueZone="valueZone"
    :zone="zone"
    :placeholder="placeholder"
    :disabled="disabled"
    v-bind="$attrs"
    v-on="listeners"
    @close="onBlur"
    @input="onInput"
    auto
  />
</template>

<script>
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.min.css'

export default {
  components: {
    VueDatetime: Datetime
  },

  props: {
    id: {
      type: String,
      require: true
    },
    invalid: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: String
    },
    type: {
      type: String,
      default: 'datetime'
    },
    zone: {
      type: String,
      default: 'local'
    },
    valueZone: {
      type: String,
      default: 'UTC'
    },
    minDatetime: {
      type: String,
      default: null
    },
    maxDatetime: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: 'primary'
    }
  },

  computed: {
    listeners () {
      const listeners = { ...this.$listeners }

      delete listeners.input
      delete listeners.blur

      return listeners
    },

    inputClasses () {
      let customClasses = []

      if (this.invalid) {
        customClasses.push('border-danger-60 shadow-outline-danger')
      }

      if (this.disabled) {
        customClasses.push('cursor-not-allowed text-grey')
      } else {
        customClasses.push('text-grey-30')
      }

      return [...DEFAULT_INPUT_CLASSES, ...COLORS[this.color], ...customClasses].join(' ')
    }
  },

  methods: {
    onInput (date) {
      this.$emit('input', date)
    },

    onBlur (event) {
      this.$emit('blur', event)
    }
  }
}

const DEFAULT_INPUT_CLASSES = [
  'w-full',
  'bg-white',
  'rounded',
  'border',
  'border-solid',
  'border-grey-80',
  'px-3',
  'text-grey-30',
  'outline-none',
  'py-2'
]

const COLORS = {
  primary: [
    'focus:shadow-outline-info',
    'focus:border-info-50'
  ],
  secondary: [
    'focus:shadow-outline-info',
    'focus:border-info-50'

  ],
  danger: [
    'focus:shadow-outline-danger',
    'focus:border-danger-50'
  ]
}
</script>

<style lang="scss">
._InputDateTime_datetime_1OczR {
  .vdatetime-overlay {
    z-index: 10000;
  }

  .vdatetime-popup {
    z-index: 10001;
    border-radius: config('borderRadius.default');
  }

  .vdatetime-popup__header {
    border-top-left-radius: config('borderRadius.default');
    border-top-right-radius: config('borderRadius.default');
  }

  &.primary {
    .vdatetime-popup__header,
    .vdatetime-calendar__month__day--selected > span > span,
    .vdatetime-calendar__month__day--selected:hover > span > span {
      background: config('colors.info-50');
    }

    .vdatetime-year-picker__item--selected,
    .vdatetime-time-picker__item--selected,
    .vdatetime-popup__actions__button {
      @apply text-info-50 font-medium;
    }
  }
}
</style>
